module.exports = __webpack_public_path__ + "img/bookImg.f7872db9.png";